import { API_BASE_URL } from '../config/api';

export class ApiError extends Error {
  constructor(message, status, payload = null) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.payload = payload;
  }
}

const DEFAULT_REQUEST_TIMEOUT_MS = 15000;

function buildUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

export async function apiRequest(path, options = {}) {
  const controller = new AbortController();
  const timeoutMs = Number(options.timeoutMs) > 0 ? Number(options.timeoutMs) : DEFAULT_REQUEST_TIMEOUT_MS;
  const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);

  let response;

  try {
    response = await fetch(buildUrl(path), {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {})
      },
      ...options,
      signal: controller.signal
    });
  } catch (error) {
    window.clearTimeout(timeoutId);

    if (error.name === 'AbortError') {
      throw new ApiError('Request timed out. Please refresh and try again.', 408);
    }

    throw error;
  }

  window.clearTimeout(timeoutId);

  const payload = await response.json().catch(() => ({
    success: false,
    data: null,
    error: 'Invalid JSON response'
  }));

  if (!response.ok || payload.success === false) {
    throw new ApiError(payload.error || `Request failed with status ${response.status}`, response.status, payload);
  }

  return payload.data;
}
